import type { ReactNode } from 'react';

export interface DonutSegment {
  value: number;
  color: string;
  label?: string;
}

export interface DonutProps {
  segments: DonutSegment[];
  size?: number;
  thickness?: number;
  label?: ReactNode;
  sub?: ReactNode;
}

export function Donut({
  segments,
  size = 120,
  thickness = 18,
  label,
  sub,
}: DonutProps) {
  if (!segments.length) return null;
  const total = segments.reduce((s, x) => s + x.value, 0) || 1;
  const r = (size - thickness) / 2;
  const c = 2 * Math.PI * r;
  let acc = 0;

  return (
    <div style={{ position: 'relative', width: size, height: size }}>
      <svg
        width={size}
        height={size}
        viewBox={`0 0 ${size} ${size}`}
        style={{ transform: 'rotate(-90deg)' }}
      >
        <circle
          cx={size / 2}
          cy={size / 2}
          r={r}
          fill="none"
          stroke="var(--dg-surface-2)"
          strokeWidth={thickness}
        />
        {segments.map((s, i) => {
          const len = (s.value / total) * c;
          const off = c - acc;
          acc += len;
          return (
            <circle
              key={i}
              cx={size / 2}
              cy={size / 2}
              r={r}
              fill="none"
              stroke={s.color}
              strokeWidth={thickness}
              strokeDasharray={`${len} ${c - len}`}
              strokeDashoffset={off}
            />
          );
        })}
      </svg>
      {label != null && (
        <div
          style={{
            position: 'absolute',
            inset: 0,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <div
            style={{
              fontSize: size * 0.22,
              fontWeight: 700,
              color: 'var(--dg-text-1)',
              letterSpacing: '-0.02em',
            }}
          >
            {label}
          </div>
          {sub != null && (
            <div style={{ fontSize: 11, color: 'var(--dg-text-3)' }}>{sub}</div>
          )}
        </div>
      )}
    </div>
  );
}
